import React from 'react';

const FooterCredits = () => {
    return (
        <>
            <section className="uk-section uk-section-secondary">
                <div className="uk-container">
                    <div className="uk-grid-divider uk-child-width-1-3@m uk-grid" uk-grid=" ">
                        <div>
                            {/* <!-- TODO --> */}
                            <p className="uk-card-title">制作团队</p>
                            <p className="uk-text-small">2019年10月11日由 <a href="https://pages.malaysiakini.com/zh" className="uk-text-secondary uk-button-text">《当今大马》新闻实验室发布</a></p>
                            <p className="uk-text-meta">项目负责人：李龙辉 | 设计：贺敬君 | 研拟：欧兴良、许安琪、艾迪拉与李龙辉 | 图像：沙里曼（Syariman Badrulzaman） | 翻译：华尤迪（Wahyudi Mohd Yunus）、阿莉莎（Arishah Ainol Shahrir）、迪亚佳（Thiaga Raj Servai）与吴湘怡 | 宣传：尤琳雁</p>
                            <p className="uk-text-small">资料来源：2010-2020年经济报告、 2010-2020年收入估算报告、1997-2018年国家银行年度报告</p>
                        </div>
                        <div>
                            {/* <!-- TODO: Please mention that it is only in English. Put it as Surat Berita (Bahasa Inggeris) or 快讯（英文） --> */}
                            <p className="uk-card-title">快讯（英文)</p>
                            <div id="newsletters">
                                <div id="mc_embed_signup">
                                    <form action="https://malaysiakini.us8.list-manage.com/subscribe/post?u=6d3e3e1c8f0ddfcdad7815052&amp;id=0fcaf42b38" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" novalidate="novalidate">
                                        <div id="mc_embed_signup_scroll">
                                            <div className="mc-field-group uk-margin">
                                                {/* <!-- TODO --> */}
                                                <label for="mce-EMAIL" className="uk-hidden">Email Address <span className="asterisk">*</span></label>
                                                <input type="email" value="" name="EMAIL" className="required email uk-input inputMailAdd" id="mce-EMAIL" placeholder="Email address" aria-required="true" />
                                            </div>
                                            <div className="mc-field-group uk-margin">
                                                {/* <!-- TODO --> */}
                                                <label for="mce-FNAME" className="uk-hidden">First Name </label>
                                                <input type="text" value="" name="FNAME" className="uk-input" id="mce-FNAME" placeholder="First name" />
                                            </div>
                                            <div className="mc-field-group uk-margin">
                                                {/* <!-- TODO --> */}
                                                <label for="mce-LNAME" className="uk-hidden">Last Name </label>
                                                <input type="text" value="" name="LNAME" className="uk-input" id="mce-LNAME" placeholder="Last name" />
                                            </div>
                                            <div id="mce-responses" className="clear">
                                                <div className="response" id="mce-error-response" style={{display:"none"}}></div>
                                                <div className="response" id="mce-success-response" style={{display:"none"}}></div>
                                            </div>
                                            <div style={{position: "absolute", left: "-5000px"}} aria-hidden="true">
                                                <input type="text" name="b_6d3e3e1c8f0ddfcdad7815052_0fcaf42b38" tabindex="-1" value=""/>
                                            </div>
                                            <div className="clear">
                                                <input type="submit" value="Sign up" name="subscribe" id="mc-embedded-subscribe" className="uk-button uk-button-primary" />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div>
                            {/* <!-- TODO --> */}
                            <p className="uk-card-title">支持我们</p>
                            <ul className="uk-text-muted" uk-nav>
                                {/* <!-- TODO --> */}
                                <li className="uk-visible@s"><a href="#boost" className="uk-text-secondary uk-button-text" uk-toggle=""><strong>喜欢我们的作品？</strong> 通过Boost手机程序资助我们的未来企划</a></li>
                                {/* <li className="uk-nav-divider"></li> */}
                                {/* <!-- TODO: For ZH page. Translate and change the url to https://subscription.malaysiakini.com/zh --> */}
                                <li><a href="https://subscription.malaysiakini.com" className="uk-text-secondary uk-button-text">支持独立媒体。 订阅当今大马 一天只需45仙。</a></li>
                            </ul>
                            <div id="boost" uk-modal="" className="uk-modal">
                                <div className="uk-modal-dialog uk-modal-body">
                                    <button className="uk-modal-close-default uk-icon uk-close" type="button" uk-close=""><svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" data-svg="close-icon">
                                            <line fill="none" stroke="#000" stroke-width="1.1" x1="1" y1="1" x2="13" y2="13"></line>
                                            <line fill="none" stroke="#000" stroke-width="1.1" x1="13" y1="1" x2="1" y2="13"></line>
                                        </svg></button>
                                    {/* <!-- TODO --> */}
                                    <p>Donate to future News Lab projects like this via Boost App.</p>
                                    <img data-src="../../img/boost-qr.png" alt="Boost App" className="uk-width-1-1" uk-img="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <style>{`
                #mc_embed_signup div#mce-responses {
                    float: left;
                    top: -1.4em;
                    padding: 0em .5em 0em .5em;
                    overflow: hidden;
                    width: 90%;
                    margin: 0 5%;
                    clear: both;
                }

                #mc_embed_signup div.response {
                    margin: 1em 0;
                    padding: 1em .5em .5em 0;
                    font-weight: bold;
                    float: left;
                    top: -1.5em;
                    z-index: 1;
                    width: 80%;
                }

                #mc_embed_signup #mce-error-response {
                    display: none;
                }

                #mc_embed_signup #mce-success-response {
                    color: #f44336;
                    display: none;
                }

                #mc_embed_signup label.error {
                    display: block;
                    float: none;
                    width: auto;
                    margin-left: 1.05em;
                    text-align: left;
                    padding: .5em 0;
                }

                #mc_embed_signup #mc-embedded-subscribe-form div.mce_inline_error {
                    display: inline-block;
                    margin: 2px 0 1em 0;
                    padding: 5px 10px;
                    background-color: rgba(255, 255, 255, 0.85);
                    font-size: 14px;
                    font-weight: normal;
                    z-index: 1;
                    color: #e85c41;
                }

                #mc_embed_signup #mc-embedded-subscribe-form input.mce_inline_error {
                    border: 2px solid #e85c41;
                }
                input.email.uk-input.inputMailAdd{
                    background-image: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAfBJREFUWAntVk1OwkAUZkoDKza4Utm61iP0AqyIDXahN2BjwiHYGU+gizap4QDuegWN7lyCbMSlCQjU7yO0TOlAi6GwgJc0fT/fzPfmzet0crmD7HsFBAvQbrcrw+Gw5fu+AfOYvgylJ4TwCoVCs1ardYTruqfj8fgV5OUMSVVT93VdP9dAzpVvm5wJHZFbg2LQ2pEYOlZ/oiDvwNcsFoseY4PBwMCrhaeCJyKWZU37KOJcYdi27QdhcuuBIb073BvTNL8ln4NeeR6NRi/wxZKQcGurQs5oNhqLshzVTMBewW/LMU3TTNlO0ieTiStjYhUIyi6DAp0xbEdgTt+LE0aCKQw24U4llsCs4ZRJrYopB6RwqnpA1YQ5NGFZ1YQ41Z5S8IQQdP5laEBRJcD4Vj5DEsW2gE6s6g3d/YP/g+BDnT7GNi2qCjTwGd6riBzHaaCEd3Js01vwCPIbmWBRx1nwAN/1ov+/drgFWIlfKpVukyYihtgkXNp4mABK+1GtVr+SBhJDbBIubVw+Cd/TDgKO2DPiN3YUo6y/nDCNEIsqTKH1en2tcwA9FKEItyDi3aIh8Gl1sRrVnSDzNFDJT1bAy5xpOYGn5fP5JuL95ZjMIn1ya7j5dPGfv0A5eAnpZUY3n5jXcoec5J67D9q+VuAPM47D3XaSeL4AAAAASUVORK5CYII=&quot;); background-repeat: no-repeat; 
                    backgroundAttachment: scroll; 
                    background-size: 16px 18px;
                    background-position: 98% 50%;
                }`}
            </style>
        </>
    )
}

export default FooterCredits;
